export default __webpack_public_path__ + "static/media/user-edit-solid.ce1784b9.svg";